import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";

export const examAdminExamsDetail = {
  pageTitle: "考试详情",
  notFound: "未找到对应考试。",
  subtitleCode: "考试编号 {code}",
  sections: {
    basicInfo: "基础信息",
    config: "考试配置",
    candidates: "考生列表",
    attempts: "作答记录",
    environments: "环境实例",
    submissions: "代码提交记录",
    scores: "评分流水",
  },
  drawers: {
    editTitle: "编辑考试",
    assignTitle: "分配考生",
    customFieldsTitle: "考试自定义字段",
  },
  candidateAssignHint: "这里只会新增分配，不会覆盖已有分配。移除已分配考生请在考生列表里单独处理。",
  candidateRequired: "至少选择一个考生",
  candidateLabel: "考生",
  actions: {
    publishScores: "发布成绩",
    publish: "发布",
    startNow: "立即开始",
    start: "开始",
    end: "结束",
    archive: "归档",
    exportRuntime: "导出结果",
    exportScores: "导出评分明细",
    assignCandidates: "分配考生",
    viewAttemptDetail: "查看",
    removeCandidate: "移除",
  },
  messages: {
    candidatesUpdated: "考生分配已更新",
    examUpdated: "考试信息已更新",
    examDeleted: "考试已删除",
    candidateRemoved: "考生已移出考试",
    scorePublished: "成绩已发布",
    statusUpdated: "考试状态已更新为 {action}",
    archivedReadonly: "归档考试为只读状态，不允许编辑",
    publishScoresUnavailable: "手动发布成绩不可用：{reason}",
    publishScoresAutoMode: "当前为自动发布成绩，无需手动发布。",
    publishScoresExamNotEnded: "考试结束后才可手动发布成绩。",
    publishScoresAlreadyPublished: "成绩已发布，无需重复发布。",
    customFieldsSaved: "考试自定义字段已保存",
    saveFailed: "保存失败",
  },
  labels: {
    assignedStatus: "已分配",
    anomalyNormal: "正常",
    currentPaperVersion: "当前版本",
    historyPaperVersion: "历史版本",
    scoreSourceAuto: "自动评分",
    scoreSourceEnvironment: "环境评分",
    scoreSourceJudge: "判题评分",
    scoreSourceAi: "AI 评分",
    scoreSourceManual: "人工评分",
    scoreSourceReview: "复核评分",
    unknownSource: "未知来源",
    commentAutoObjectiveScoring: "系统自动客观题评分",
  },
  actionsExtra: {
    viewPaper: "查看试卷",
    checkPaperUpdates: "检查更新",
    customFields: "自定义字段",
  },
  tabs: {
    rules: "规则配置",
    candidates: "考生作答",
    analysis: "考试分析",
    monitoring: "运行监控",
    scores: "评分流水",
  },
  ruleGroups: {
    entry: "考试准入",
    submission: "提交与评分",
    runtime: "运行策略",
  },
  table: {
    candidate: "考生",
    assignmentStatus: "分配状态",
    assignedAt: "分配时间",
    attempt: "作答",
    attemptId: "作答ID",
    candidateId: "考生 ID",
    score: "得分",
    anomaly: "异常",
    time: "时间",
    instanceId: "实例 ID",
    submissionId: "提交 ID",
    judgeResult: "判题结果",
    submittedAt: "提交时间",
    scoreRecordId: "记录 ID",
    source: "来源",
    comment: "评语",
    includedInFinal: "计入最终分",
  },
  candidateTable: {
    startedAt: "开始时间",
    submittedAt: "交卷时间",
    usedMinutes: "用时",
    usedMinutesValue: "{minutes} 分",
    anomaly: "异常",
    objectiveSubjectiveScore: "客观 {objective} / 主观 {subjective}",
  },
  basicInfo: {
    status: commonShortNouns.status,
    paperTitle: "试卷名称",
    paperCode: "试卷编号",
    paperVersionCode: "试卷版本编号",
    paperVersionId: "试卷版本编号",
    entryCode: "入口编码",
    entrySubdomain: "入口二级域名",
    duration: "考试时长",
    actualEndTime: "实际结束时间",
    publishScoreMode: "成绩发布方式",
    resultVisibility: "成绩可见性",
    answerVisibility: "答案可见性",
    allowLateEntry: "允许迟到进入",
    lateEntryGraceMinutes: "最大迟到时长",
    allowReentry: "允许中断重进",
    allowMultipleSubmit: "允许多次提交",
    maxAttemptCount: "最多作答次数",
    candidateEnvironmentMaxActive: "每考生并发容器上限",
    candidateEnvironmentMaxTotal: "每考生容器创建次数上限",
    createdAt: commonShortFieldLabels.createdAt,
  },
  summary: {
    candidates: "已分配考生：{count}",
    attempts: "作答记录：{count}",
    environments: "环境实例：{count}",
    submissions: "代码提交：{count}",
    anomalies: "异常作答：{count}",
    scorePublished: "成绩已发布：{value}",
    scorePublishedAt: "发布时间：{value}",
  },
  filters: {
    showAnomaliesOnly: "仅看异常作答",
    attemptStatus: "筛选状态",
    candidate: "筛选考生",
    environmentStatus: "筛选环境状态",
    verdict: "筛选判题结果",
    scoreSource: "筛选评分来源",
    candidateByCandidate: "按考生筛选",
  },
  overviewStats: {
    expectedCandidates: "应考人数",
    participants: "参与人数",
    entered: "已进入",
    submitted: "已交卷",
    anomalies: "异常人数",
  },
  timeFields: {
    hourMinuteSecond: "{hour}时{minute}分{second}秒",
    minuteSecond: "{minute}分{second}秒",
    second: "{second}秒",
  },
  candidateMetrics: {
    attendanceRate: "到考率",
    attendanceRateHint:
      "到考率 = 已进入 / 基准人数。指定考试基准=应考人数；开放考试基准=当前参与人数。",
    completionRate: "完卷率",
    completionRateHint:
      "完卷率 = 已交卷 / 基准人数。指定考试基准=应考人数；开放考试基准=已进入人数。",
    anomalyRate: "异常率",
    anomalyRateHint: "异常率 = 异常人数 / 基准人数。",
    averageScore: "平均分",
  },
  candidateFilters: {
    status: "筛选状态",
    keyword: "按姓名/用户名搜索",
    onlyAnomalies: "仅看异常",
    onlySubmitted: "仅看已交卷",
    clear: "清空筛选",
    quickAnomalies: "一键看异常",
    quickSubmitted: "一键看已交卷",
    exportCurrent: "导出当前筛选",
  },
  analysis: {
    coreMetrics: "核心指标",
    averageScore: "平均分",
    medianScore: "中位分",
    highestScore: "最高分",
    lowestScore: "最低分",
    scoreDistribution: "分数分布",
    scoreTypeStats: "题型评分统计",
    submissionBehavior: "提交行为",
    submissionTotal: "代码提交总数",
    involvedAttempts: "涉及作答数",
    avgSubmissionsPerAttempt: "平均提交次数/作答",
    scoreBucketRange: "分数段",
    scoreBucketCount: "人数",
    scoreBucketRatio: "占比",
    scoreType: "题型",
    scoreRecordCount: "评分条数",
    avgScore: "平均得分",
  },
  scoreSummary: {
    title: "评分流水",
    totalRecords: "评分记录总数",
    questionTypeCount: "覆盖题型数",
    sourceCount: "评分来源数",
    sourceTag: "{source}：{count} 条 (平均分: {avg})",
  },
  empty: {
    extraConfig: "暂无扩展配置",
    candidateRows: "暂无符合筛选条件的考生作答记录",
    monitoring: "暂无运行记录，考试可能尚未开始或无相关数据",
    scores: "暂无评分记录，可能尚未完成评分或提交",
  },
  extraConfigLabels: {
    seedKey: "种子标识",
    seedBundle: "种子分组",
    typeRuntimePolicies: "题型运行策略",
  },
  questionTypes: {
    singleChoice: "单选题",
    multipleChoice: "多选题",
    judgment: "判断题",
    shortAnswer: "简答题",
    code: "编程题",
    practical: "实操题",
    attackDefense: "夺旗题",
  },
  runtimePolicy: {
    shuffleQuestions: "题目乱序 {value}",
    shuffleOptions: "选项打乱 {value}",
    allowSelfCheck: "自主检测 {value}",
    maxSelfCheckCount: "检测上限 {count} 次",
  },
  staffRoles: {
    sectionTitle: "考试内考务角色",
    searchPlaceholder: "搜索考务人员",
    clear: "清空",
    assign: "分配考务角色",
    empty: "当前考试暂无分配的考务角色",
    assignDrawerTitle: "分配考试内考务角色",
    assignHint: "可将监考/阅卷按考试分配给考务人员；归档考试不可修改。",
    staffLabel: "考务人员",
    staffRequired: "请选择考务人员",
    roleLabel: "考试内角色",
    roleRequired: "请选择至少一个角色",
    tableStaff: "考务人员",
    tableUserStatus: "账号状态",
    tableRoles: "考试内角色",
    removeConfirmTitle: "移除该考试内角色？",
    removePrefix: "移除",
  },
  confirm: {
    removeCandidateTitle: "确认移除该考生？",
    removeCandidateDescription: "如果该考生已经产生作答记录，后端会拒绝移除。",
    publishExamTitle: "确认发布考试？",
    publishExamDescription: "发布考试后，考试状态将变为已发布，请确认操作。",
    startExamTitle: "确认开始考试？",
    startExamDescription: "开始考试后，考试将进入运行状态，请确认操作。",
    start_nowExamTitle: "确认立即开始考试？",
    start_nowExamDescription: "考试将立即开始运行，考生可以立即进入答题，请确认操作。",
    publish_scoresExamTitle: "确认发布成绩？",
    publish_scoresExamDescription: "发布成绩后，考生将可以查看自己的考试成绩，请确认操作。",
    endExamTitle: "确认结束考试？",
    endExamDescription: "考试结束后，考生将无法继续答题，请确认操作。",
    archiveExamTitle: "确认归档考试？",
    archiveExamDescription: "考试归档后，相关数据将被锁定，请确认操作。",
    deleteExamTitle: "确认删除考试？",
    deleteExamDescription: "仅草稿考试允许删除，删除后不可恢复，请确认操作。",
  },
};
